// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".terms-card[data-v-3ceaac20] {\n  background-color: #232323 !important;\n}\n.fade-overlay[data-v-3ceaac20] {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 60px;\n  z-index: 5;\n  border-radius: 15px;\n  background-image: linear-gradient(rgba(35,35,35,0) 0%, #232323 100%);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
